module.exports = __webpack_public_path__ + "static/media/UploadIcon.ae51ad47.svg";